import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

function loadRuntimeConfig() {
  if (typeof window === "undefined") {
    return null;
  }

  const config = window.__FISHMAP_NEW_RELIC_CONFIG__;
  if (!config?.info || !config?.loader_config) {
    return null;
  }

  return {
    init: config.init || {},
    info: config.info,
    loader_config: config.loader_config,
  };
}

function loadBuildTimeConfig() {
  const licenseKey = process.env.REACT_APP_NEW_RELIC_BROWSER_LICENSE_KEY;
  const applicationID = process.env.REACT_APP_NEW_RELIC_APP_ID;
  const accountID = process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID;
  const trustKey = process.env.REACT_APP_NEW_RELIC_TRUST_KEY || accountID;

  if (!licenseKey || !applicationID || !accountID) {
    return null;
  }

  const appId = Number(applicationID);
  const accountId = Number(accountID);

  return {
    init: {
      ajax: { deny_list: ["bam.eu01.nr-data.net"] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: { cookies_enabled: true },
    },
    info: {
      applicationID: appId,
      beacon: "bam.eu01.nr-data.net",
      errorBeacon: "bam.eu01.nr-data.net",
      licenseKey,
      sa: 1,
    },
    loader_config: {
      accountID: accountId,
      agentID: appId,
      applicationID: appId,
      licenseKey,
      trustKey: Number(trustKey),
    },
  };
}

const options = loadRuntimeConfig() || loadBuildTimeConfig();

if (options) {
  new BrowserAgent(options);
} else if (process.env.NODE_ENV === "production") {
  console.warn("[New Relic] Browser agent not configured.");
}

export function noticeNewRelicError(error, customAttributes) {
  if (typeof window === "undefined") {
    return;
  }

  const noticeError = window.newrelic?.noticeError;
  if (typeof noticeError !== "function") {
    return;
  }

  noticeError.call(window.newrelic, error, customAttributes);
}
